import PropTypes from 'prop-types'
import {
  Button,
  Divider,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import DineroPropShape from '~/utils/propTypes/dinero'
import {PayablePropType} from '../../../../propTypes'

const i18nPrefix = 'pointsOnPayments:paymentWizard.formPanel.confirmPaymentModal'

const DetailRow = ({label, value}) => (
  <Flex justify="space-between">
    <Text textStyle="body-copy">{label}</Text>
    <Text textStyle="body-copy-medium">{value}</Text>
  </Flex>
)

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

const ConfirmPaymentModal = ({
  isOpen,
  onCancel,
  onConfirm,
  payable,
  totalAmount,
  isSubmitting,
}) => {
  const {t} = useTranslation('pointsOnPayments')

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="md"
      preserveScrollBarGap
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton isDisabled={isSubmitting} />
        <ModalHeader>
          <Text textStyle="body-intro-medium">{t(`${i18nPrefix}.title`)}</Text>
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" gap="md">
            <Text textStyle="body-copy" color="mld.neutral.700">
              {t(`${i18nPrefix}.subTitle`)}
            </Text>
            <Flex direction="column" gap="xxs">
              <DetailRow
                label={t(`${i18nPrefix}.payeeLabel`)}
                value={payable.payeeName}
              />
              <DetailRow
                label={t(`${i18nPrefix}.branchCodeLabel`)}
                value={payable.payee.bankAccount.bsb}
              />
              <DetailRow
                label={t(`${i18nPrefix}.accountNumberLabel`)}
                value={payable.payee.bankAccount.accountNumber}
              />
            </Flex>
            <Divider borderColor="mld.neutral.700" />
            <Flex justify="space-between">
              <Text textStyle="body-copy" fontWeight="bold">
                {t(`${i18nPrefix}.totalLabel`)}
              </Text>
              <Text textStyle="body-copy" fontWeight="bold">
                {totalAmount?.toFormat()}
              </Text>
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter gap="sm" justifyContent="flex-start">
          <Button
            variant="primary"
            onClick={onConfirm}
            isLoading={isSubmitting}
            textTransform="uppercase"
          >
            {t(`${i18nPrefix}.confirmButton`, {
              context: totalAmount ? 'withAmount' : 'withoutAmount',
              amount: totalAmount?.toFormat(),
            })}
          </Button>
          <Button
            variant="secondary"
            onClick={onCancel}
            isDisabled={isSubmitting}
          >
            {t(`${i18nPrefix}.cancelButton`)}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ConfirmPaymentModal.defaultProps = {
  totalAmount: null,
  isSubmitting: false,
}

ConfirmPaymentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  payable: PayablePropType.isRequired,
  totalAmount: PropTypes.shape(DineroPropShape),
  isSubmitting: PropTypes.bool,
}

export default ConfirmPaymentModal
